var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogle = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 21,
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1070_26884)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.9895 10.6868C19.9895 9.86743 19.9214 9.26949 19.7742 8.64941H10.1992V12.3477H15.8195C15.7062 13.2668 15.0943 14.6509 13.7346 15.581L13.7155 15.7048L16.7429 17.9967L16.9527 18.0171C18.8789 16.2786 19.9895 13.7208 19.9895 10.6868Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.1993 20.4307C12.9527 20.4307 15.2643 19.5448 16.9527 18.0168L13.7346 15.5807C12.8734 16.1676 11.7176 16.5773 10.1993 16.5773C7.50242 16.5773 5.21352 14.8389 4.39759 12.436L4.27799 12.446L1.13003 14.8266L1.08887 14.9385C2.76588 18.1939 6.2106 20.4307 10.1993 20.4307Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.39748 12.4363C4.18219 11.8163 4.05759 11.1518 4.05759 10.4653C4.05759 9.77878 4.18219 9.11443 4.38615 8.49435L4.38045 8.36229L1.19304 5.94336L1.08876 5.99183C0.397576 7.34275 0.000976562 8.85977 0.000976562 10.4653C0.000976562 12.0709 0.397576 13.5879 1.08876 14.9388L4.39748 12.4363Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.1993 4.35287C12.1142 4.35287 13.406 5.16119 14.1425 5.83669L17.0207 3.09058C15.253 1.48501 12.9527 0.499512 10.1993 0.499512C6.2106 0.499512 2.76588 2.73623 1.08887 5.99165L4.38626 8.49417C5.21352 6.09134 7.50242 4.35287 10.1993 4.35287Z",
  fill: "white"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1070_26884"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(0 0.499512)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google.e9807feb91b9db16128e52d1aab3a81b.svg";